import gql from 'graphql-tag';

const MARK_CONVERSATION_AS_READ = gql`
  mutation MarkConversationAsRead($conversationId: ID!, $userId: ID!) {
    markConversationAsRead(conversationId: $conversationId, userId: $userId)
  }
`;

export default {
  MARK_CONVERSATION_AS_READ,
};
